module.exports = __webpack_public_path__ + "fonts/Roboto-Black.5ebb24ee.ttf";